const VIDEO = {
    onReady() {
        VIDEO.build();
    },
    build() {
        const videos = document.querySelectorAll('[data-youtube-id]');
        videos.forEach(video => {
            video.addEventListener('click', event => {
                let id     = video.dataset.youtubeId;
                let markup = `<figure><iframe class="video__iframe" src="https://www.youtube-nocookie.com/embed/${id}?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></figure>`;
                video.classList.add('hidden');
                video.parentNode.querySelector('.video__disclaimer').classList.add('hidden');
                video.nextElementSibling.insertAdjacentHTML('afterbegin', markup);
            });
        });
    }
}